import React from "react";
import BrandLogo from "../common/BrandLogo";

const API_BASE = process.env.REACT_APP_API_URL || "https://go.brandhives.com";

export default function ReauthPage() {
  const handleLinkedIn = () => {
    const tempId = typeof crypto !== "undefined" && crypto.randomUUID
      ? crypto.randomUUID()
      : `tmp-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    window.location.href = `${API_BASE}/app/api/auth/linkedin/connect?temp_id=${tempId}&source=reauth`;
  };

  return (
    <div style={{ background: "#F3F2EF", minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "-apple-system,'Segoe UI',Helvetica,sans-serif" }}>
      <div style={{ maxWidth: 440, width: "100%", padding: "48px 24px", textAlign: "center" }}>
        <BrandLogo size="lg" showSub={false} style={{ flexDirection: "column", textAlign: "center", justifyContent: "center" }} />
        <h1 style={{ fontFamily: "'Playfair Display',Georgia,serif", fontSize: 26, fontWeight: 700, color: "#1A1A1A", margin: "36px 0 12px" }}>Reconnect your LinkedIn</h1>
        <p style={{ fontSize: 15, color: "#666", lineHeight: 1.6, margin: "0 0 32px" }}>
          LinkedIn connections expire every 60 days. Reconnect to keep your posts going out.
        </p>
        <button
          onClick={handleLinkedIn}
          style={{
            display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 10,
            background: "#0077B5", color: "#fff", border: "none", borderRadius: 8,
            padding: "14px 32px", fontSize: 15, fontWeight: 600, cursor: "pointer",
            fontFamily: "-apple-system,'Segoe UI',Helvetica,sans-serif", minHeight: 48,
          }}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="#fff"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
          Sign in with LinkedIn
        </button>
      </div>
    </div>
  );
}
